/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React from "react";
import { breakpoints } from "../../../components/breakpoints";

interface FormRowProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

const style = css`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  ${breakpoints.tablet} {
    flex-direction: column;
  }
`;

export const FormRow = ({ children, ...rest }: FormRowProps) => {
  return (
    <div css={style} {...rest}>
      {children}
    </div>
  );
};
